const EditKnowledgeBase = (props) => <div className={'hover'}>
  <a className='btn btn-default btn-edit' href={props.link}>Edit</a>
</div>

export default EditKnowledgeBase
